{
  "dev": {
    "protocol": "https",
    "host":"http://assets.lmaxglobal.io",
    "path":"static_assets/trade_latency_data",
    "endpoints": {
      "latencyData": "/data.json"
    },
    "chartEndpoint": {
        "chartServer": "charts.app.lmax.com",
        "chartPath": "{protocol}://{chartServer}/chartv6/L/{venue}/{symbol}/{fieldspec}/{interval}?chartiq=1&obj=1&nostart={noStart}",
        "headers": {
          "x-lmax-chartkey": "b9fcb6ebb98620470abbe2dc8324e728a84472c6ca8f9e9a1d8b7e206d25da39"
        }
      }
  },
  "prod": {
    "protocol": "https",
    "host":"https://assets.app.lmax.com",
    "path":"static_assets/trade_latency_data",
    "endpoints": {
      "latencyData": "/data.json"
    },
    "chartEndpoint": {
        "chartServer": "charts.app.lmax.com",
        "chartPath": "{protocol}://{chartServer}/chartv6/L/{venue}/{symbol}/{fieldspec}/{interval}?chartiq=1&obj=1&nostart={noStart}",
        "headers": {
          "x-lmax-chartkey": "b9fcb6ebb98620470abbe2dc8324e728a84472c6ca8f9e9a1d8b7e206d25da39"
        }
      }
  },
  "venues":{
    "BROKT1": {
      "label": "Broker Sharp",
      "venue": "brokt1",
      "endpoint": {
        "url": "https://md.app.lmax.com/brokt1/instruments/depths",
        "headers": {
          "key": "value1"
        }
      },
      "fayeDetails": {
        "path": "/fayefixprof",
        "channel": "/brokt1/deptharray/{symbol}",
        "depthmaxChannel": "/brokt1/depthmax/{symbol}"
      },
      "priceFormatter": "globalPriceFormatter",
      "spreadv6": [
        {
          "urlBase": "/spreadv6/L/brokt1/",
          "legend": "Broker Sharp"
        }
      ]
    },
    "FIXPROF": {
      "label": "Fixprof",
      "venue": "fixprof",
      "endpoint": {
        "url": "https://md.app.lmax.com/fixprof/instruments/depths"
      },
      "spreadv6": [
        {
          "urlBase": "/spreadv6/L/fixprof/",
          "legend": "Fixprof"
        }
      ]
    }
  }
}


